import { Menu as ChakraMenu } from '@chakra-ui/react';
import { ReactElement } from 'react';

import { MenuProps } from './menu.types';

export default function Menu(props: MenuProps): ReactElement {
  return <ChakraMenu {...props} />;
}
